export default {
  data() {
    return {
      pagina: 1,
      quantidadePagina: 10,
      rows: []
    };
  },
  computed: {
    qtPaginaAtual() {
      return this.zeroEsquerda(this.rowsComputed.length, 2);
    },
    qtPaginas() {
      if (this.qtTotal === 0) return 1;
      return Math.ceil(this.qtTotal / this.quantidadePagina);
    },
    rowsComputed() {
      return this.rows.filter((el, index) => this.funcaoFilter(index));
    },
    qtTotal() {
      return this.rows.length;
    }
  },
  methods: {
    funcaoFilter(index) {
      let start = (this.pagina - 1) * this.quantidadePagina;
      let end = this.pagina * this.quantidadePagina;
      return index >= start && index < end;
    }
  }
};
